<template>
  <div class="ibox-child">
    <div class="row">
      <div class="form-group col-sm-12 info-status">
        <div class="panel">
          <div class="relation-body">
            <label class="control-label status-label" for="status">{{$t('relatedOkrType')}}</label>
            <div class="panel-footer info-add">
              <a @click="emitRelation" class="btn btn-success add-relation" href="#"><i class="fa fa-plus"></i>{{$t('addStr')}}</a>
            </div>
          </div>
          <div class="ibox-content relation-box">
            <ul>
              <li v-for="(obj, key) in getCheckedObjectivesInfo" :key="obj.id" v-if="obj.contentText">
                <div class="relation-object">
                  <objective-knob :progress="obj.progress ? Number(obj.progress) : 0" :readOnly="true"></objective-knob>
                  <span class="relation-object-text">
                    <span class="info-username">{{ getUserInfoById(obj.userId).userName }}</span>
                    <read-more :text="obj.contentText" :addMore="false" :showMore="propShowMore" @update-show-more="updateShowMore" @update-content-height="updateContentHeight">
                      {{obj.contentText}}
                    </read-more>
                  </span>
                </div>
                <div class="ibox-tools">
                  <span class="info-menu"></span>
                  <span class="info-right">
                    <a class="info-comment-detail" href="#">
                      <img src="static/img/assets/comment.png">
                      <span>{{getCommentsByItemId(key, obj.targetType).length}}</span>
                    </a>
                    <span class="info-comment-detail due-date-color">{{$t('dueDateStr')}} : {{obj.dueDate}}</span>
                    <okr-drop-down :tag="tag" :item="obj" :id="key" v-on:delete-relation="deleteRelation"/>
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ObjectiveKnob from '@/components/Okr/ObjectiveKnob'
import { mapGetters } from 'vuex'
import moment from 'moment'
import OkrDropDown from '@/components/Okr/OkrDropDown'
import ReadMore from '@/components/ReadMore/ReadMoreComponent'

export default {
  name: 'RegistRelation',
  components: {
    ObjectiveKnob,
    OkrDropDown,
    ReadMore
  },
  props: {
    checkedObjectives: Array
    // detailView: {
    //   type: Boolean
    // }
  },
  computed: {
    ...mapGetters('objectives/', [
      'getObjectivesByIds'
    ]),
    ...mapGetters('comments/', [
      'getCommentsByItemId'
    ]),
    ...mapGetters('users/', [
      'getUserInfoById'
    ]),
    getCheckedObjectivesInfo: function () {
      console.log('this.checkedObjectives', this.checkedObjectives)
      console.log('array', this.getObjectivesByIds(this.checkedObjectives))
      return this.getObjectivesByIds(this.checkedObjectives)
    }
  },
  data: function () {
    return {
      tag: 'registRelation',
      targetType: 'objectives',
      propShowMore: false,
      propContentHeight: 0
    }
  },
  methods: {
    emitRelation: function () {
      this.$emit('openRelation', 'relation')
    },
    deleteRelation: function (id, type) {
      this.$emit('delete-relation', id, type)
    },
    updateShowMore: function (value) {
      this.propShowMore = value
    },
    updateContentHeight: function (value) {
      this.propContentHeight = value
    }
  },
  updated: function () {
    console.log(this.checkedObjectives)
  },
  filters: {
    preparedTime: function (date) {
      return moment(date * 1000).format('YYYY/MM/DD HH:mm')
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Regist/RegistRelation.vue